import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=2c67213a&"
import script from "./InputBox.vue?vue&type=script&lang=js&"
export * from "./InputBox.vue?vue&type=script&lang=js&"
import style0 from "./InputBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports